import { Component, HostBinding, Input, OnInit } from "@angular/core"
import { ErrorCode } from "../error-code.model"
import { CHNode } from "../../models/node.model"
import { LearningObject } from "../../models/learningObject.model"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-unauthorized-error",
    templateUrl: "./unauthorized-error.component.html",
    styleUrls: ["./unauthorized-error.component.scss"],
})
export class UnauthorizedErrorComponent implements OnInit {
    public image: string
    public ErrorCode = ErrorCode
    public isStudent: boolean

    @HostBinding("style") hostBinding = "flex: 1"

    @Input()
    public nextURL: string

    @Input()
    public errorCode: ErrorCode

    @Input()
    public errorMessage: string

    @Input()
    public showContent: boolean = false

    @Input()
    public subjects: CHNode[] = []

    @Input()
    public learningObjects: LearningObject[] = []

    constructor(private userService: UserService) {}

    ngOnInit(): void {
        this.image = require("../../../assets/Lost-in-Space.png").default
        this.isStudent = this.userService.hasStudentExperience()
    }
}
